import { IAngularEvent, IComponentOptions, IController } from "angular";

interface INoSearchItemsFoundBindings {
  facets: string[];
  indicators: {
    gettingSearchData: boolean;
    loadingMore: boolean;
    loading: boolean;
  };
  stateView: boolean;
  facetToggleOptions: { [facetName: string]: string };
  currentFacet: string;
  searchTerm: string;
  onFacetChange(params: { $event: IAngularEvent; facet: string; searchTerm: string }): void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface NoSearchItemsFoundCtrl extends INoSearchItemsFoundBindings {}
class NoSearchItemsFoundCtrl implements IController {
  searchEverywhere($event: IAngularEvent): void {
    this.onFacetChange({ $event, facet: this.facetToggleOptions.everywhere, searchTerm: this.searchTerm });
  }
}

export const NoSearchItemsFoundComponent: IComponentOptions = {
  controller: NoSearchItemsFoundCtrl,
  template: require("./no-search-items-found.html"),
  bindings: {
    facets: "<",
    indicators: "<",
    stateView: "<",
    facetToggleOptions: "<",
    currentFacet: "@",
    searchTerm: "@",
    onFacetChange: "&",
  },
};
